import React, { useState, useEffect, useRef, useCallback } from "react";
import { Draggable } from "react-beautiful-dnd";
import TicketNuevo from "./TicketNuevo";

const DraggableTicketNuevo = ({ ticket, index }) => {
  const [isDragging, setIsDragging] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [click, setClick] = useState(false);
  const ticketRef = useRef(null);
  const containerRef = useRef(null);

  const handleMouseMove = useCallback(
    (e) => {
      if (click) {
        setIsDragging(true);
      }
      if (isDragging) {
        const containerRect = containerRef.current.getBoundingClientRect();
        const ticketRect = ticketRef.current.getBoundingClientRect();
        setPosition({
          x: e.clientX - containerRect.left - ticketRect.width / 7,
          y: e.clientY - containerRect.top - ticketRect.height / 3,
        });
      }
    },
    [click, isDragging]
  );

  const handleMouseUp = useCallback(() => {
    setIsDragging(false);
    setClick(false);
  }, []);

  useEffect(() => {
    if (isDragging) {
      window.addEventListener("mousemove", handleMouseMove);
      window.addEventListener("mouseup", handleMouseUp);
    }
    return () => {
      if (isDragging) {
        window.removeEventListener("mousemove", handleMouseMove);
        window.removeEventListener("mouseup", handleMouseUp);
      }
    };
  }, [isDragging, handleMouseMove, handleMouseUp]);

  const handleMouseDown = useCallback(() => {
    setClick(true);
  }, []);

  return (
    <>
      <Draggable draggableId={ticket.id} index={index}>
        {(provided) => (
          <div
            ref={(el) => {
              provided.innerRef(el);
              ticketRef.current = el;
            }}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            onMouseDown={handleMouseDown}
            style={{
              ...provided.draggableProps.style,
              position: isDragging ? "fixed" : "relative",
              left: isDragging ? position.x : undefined,
              top: isDragging ? position.y : undefined,
              zIndex: isDragging ? 10000 : undefined, // Asignar un valor alto y fijo de zIndex cuando se está arrastrando
            }}
          >
            <TicketNuevo {...ticket} />
          </div>
        )}
      </Draggable>
      {isDragging && (
        <div
          ref={containerRef}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            pointerEvents: "none",
            opacity: 1,
            zIndex: 9999,
            background: "blue",
          }}
        >
          <div></div>
        </div>
      )}
    </>
  );
};

export default DraggableTicketNuevo;